var style = {"modalBody":"ModalBody-module_modalBody__P8un0","modalBodyScrollable":"ModalBody-module_modalBodyScrollable__SuV88"};

export { style as default };
//# sourceMappingURL=ModalBody.module.scss.js.map
